import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const citiesService = {
    // Public list of serviceable (active) cities. The admin manages the catalog
    // elsewhere; this endpoint only returns active ones used for the
    // serviceability check on the create-order flow.
    getActive: async () => {
        try {
            const res = await axiosService.get(endPoints.cities.public);

            return res;
        } catch (error) {
            throw error;
        }
    },
}

export {
    citiesService,
}
